<template>
	<modal ref="modal">
		<template #title>UPDATE DELIVERY FREEBOOK CONTENT</template>
		<template #body>
			
			<div class="form-floating mb-4">
				<div class="form-control">{{form.fname}} {{form.lname}}</div>
				<label class="form-label" for="amount">Name</label>
			</div>

			<div class="form-floating mb-4">
				<div class="form-control">{{form.email}}</div>
				<label class="form-label" for="amount">Email</label>
			</div>

			<div class="form-floating mb-4">
				<div class="form-control"><span class="badge bg-success me-1">{{form.mop}}</span>PHP {{form.amount}}</div>
				<label class="form-label" for="amount">Amount</label>
			</div>
						
			<div class="form-floating mb-4">
				<select v-model="form.status" id="status" name="status" class="form-select" placeholder="Payment Status">
                  <option value="S">Completed</option>
                  <option value="P">Pending</option>
                </select>
				<label class="form-label" for="status">Payment Status</label>
			</div>

			<div class="form-floating mb-4">
				<textarea v-model="form.remark" class="form-control" style="height:200px;"></textarea>
				<label class="form-label" for="amount">Remark</label>
				<span v-if="form.errors.remark" class="text-danger">{{form.errors.remark}}</span>
			</div>

			<div v-if="form.status=='S'">
				<div class="form-floating mb-4">
					<select v-model="form.delivery_status" id="delivery_status" name="delivery_status" class="form-select" placeholder="Delivery Status">
	                  <option value="Pending">Pending</option>
	                  <option value="Shipped">Shipped</option>
	                  <option value="Delivered">Delivered</option>
	                </select>
					<label class="form-label" for="delivery_status">Delivery Status</label>
				</div>

				<div class="form-floating mb-4">
					<textarea v-model="form.delivery_remark" class="form-control" style="height:200px;"></textarea>
					<label class="form-label" for="delivery_remark">Delivery Remark</label>
					<span v-if="form.errors.delivery_remark" class="text-danger">{{form.errors.delivery_remark}}</span>
				</div>
				<div v-if="form.delivery_status!='Pending'">
					<div class="form-floating mb-4">
						<select v-model="form.courier" id="courier" name="courier" class="form-select" placeholder="Courier">
		                  <option value="ninjavan">ninjavan</option>
		                  <option value="shopee">shopee</option>
		                  <option value="lazada">lazada</option>
		                  <option value="lbc">lbc</option>
		                  <option value="jnt">jnt</option>
		                  <option value="others">others</option>
		                </select>
						<label class="form-label" for="courier">Courier</label>
					</div>
					<div class="form-floating mb-4">
						<input v-model="form.tracking_link" type="text" name="tracking_link" class="form-control" placeholder="">
						<label class="form-label" for="tracking_link">tracking_link</label>
					</div>
				</div>
			</div>

		</template>
		<template #footer>
			<button 
				@click="updateContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing"
			>
					<i v-if="!form.processing" class="fa fa-save me-2"></i>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
					<span>Update</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	props: {
		errors : Object
	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const form = useForm({
			deliery_freebook_uuid 	: null,
			fname					: '',
			lname					: '',
			email 					: '',
			mobile 					: '',
			mop 					: '',
			amount 					: 0,
			old_status 				: '',
			status 					: '',
			remark 					: '',
			delivery_status 		: '',
			delivery_remark 		: '',
			courier 				: '',
			tracking_link 			: '',
			source 					: '',
		})

		const updateContent = () => {
			form.put('freebook/'+form.delivery_freebook_uuid, {
				preserveState: true,
				preserveScroll: true,
				only:['deliveryFreebooks,api_response','region','status','delivery_status','search','errors'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setDeliveryFreebookContent = (data)=>{
								
								form.reset();

								form.delivery_freebook_uuid 	= data.delivery_freebook_uuid;
								form.fname 						= data.fname;
								form.lname 						= data.lname;
								form.email 						= data.email;
								form.mobile 					= data.mobile;
								form.mop 						= data.mop;
								form.amount 					= data.amount;
								form.old_status 				= data.status;
								form.status 					= data.status;
								form.delivery_status 			= data.delivery_status;
								form.courier 					= data.courier;
								form.tracking_link 				= data.tracking_link;
								form.source 					= data.source;
								
							}


		return {
			form,
			modal,
			toggleModal,
			setDeliveryFreebookContent,
			updateContent,
		}
	},
}
</script>
